// extracted by mini-css-extract-plugin
export default {"bannerComponent":"Il-z","red":"Jl-z","calloutlink":"Kl-z","headerTopBanner":"Ll-z","bgcolorRed":"Ml-z","headerTopCallout":"Nl-z","searchBanner":"Ol-z","hideMobile":"Pl-z"};